import React from 'react';
import styled from 'styled-components';

import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography/TypographyRebrand';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

import Head from '../Head';

/*
 * LUT-524: full-page state shown instead of the Employer Center to partner-request
 * accounts that have not been approved yet (organization.is_partner is persisted at
 * signup, approval is the arrival of upward grants). Rendered from withGrants in
 * place of the page component, so no dashboard or nav is exposed.
 */

const StyledContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 80px;

  @media (min-width: ${styles.breakpoint.md}) {
    height: calc(100vh - 108px);
    padding-top: unset;
    width: 100%;
  }
`;

const StyledTypography = styled(Typography)`
  text-align: left;

  @media (min-width: ${styles.breakpoint.md}) {
    text-align: center;
  }
`;

const AccountUnderReviewWidget = () => (
  <>
    <Head title="Your account is under review" />
    <StyledContainer>
      <StyledTypography variant={VARIANTS.H1}>
        Your account is under review.
      </StyledTypography>
      <StyledTypography>
        Thanks for signing up. Our team is reviewing your partner account request.
        You will be able to access the partner tools as soon as your request is approved.
      </StyledTypography>
    </StyledContainer>
  </>
);

export default AccountUnderReviewWidget;
